import React, { useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Icon, Text } from '@perch-labs/shrike';
import { formatDate } from '@perch-labs/warbler';
import { CleanKwh } from 'contexts/clean-kwh';
import { ErrorModule } from 'components/errors';
import { LoadingModule } from 'components/loading';
import { routes, copyFor } from 'config';
import { CardImage } from './wind-project.style';

const getCopy = copyFor('modules.windProject');

interface Props {
  withLink?: boolean;
}

export const WindProject = ({ withLink = true }: Props) => {
  const history = useHistory();
  const { planId } = useParams<{ planId?: string }>();
  const { cleanKwh, loading, error } = useContext(CleanKwh);

  if (loading) return <LoadingModule />;
  if (error) return <ErrorModule title={getCopy('title')} />;

  const { endDate, featuredWindProject, kwh, startDate } = cleanKwh;
  const { id, imageUrl, location, name, projectType, state } =
    featuredWindProject;

  const { projects } = routes({ planId, projectId: id });
  const description = getCopy('description', {
    endDate: formatDate(endDate, { format: 'MMM d' }),
    kwh,
    location,
    name,
    startDate: formatDate(startDate, { format: 'MMM d' }),
    state,
  });

  const icon = (
    <Icon
      icon="ChevronRight"
      title={getCopy('title')}
      scale={3}
      color="secondary"
    />
  );

  let headerProps = {
    title: getCopy('title'),
  };
  if (withLink) {
    headerProps = {
      ...headerProps,
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ icon: { JSX.Element; ... Remove this comment to see the full error message
      icon,
      onClick: () => history.push(projects),
      to: projects,
    };
  }

  return (
    <Card mobileVariant="flat">
      <Card.Header {...headerProps} />
      <Card.Content>
        <Text margin={{ bottom: '8px' }}>{description}</Text>
        <CardImage src={imageUrl} alt={getCopy('alt', { projectType })} />
      </Card.Content>
    </Card>
  );
};
